import CalamityIndicatorView from "./CalamityIndicatorView";

function CalamityIndicator() {
  return <CalamityIndicatorView />;
}

export default CalamityIndicator;
